import { Box, BoxProps } from "@chakra-ui/react";
import { motion } from "framer-motion";
import { PropsWithChildren, useId } from "react";

interface PageMotionProps extends PropsWithChildren<BoxProps> {
  subpage?: boolean;
}

const MotionBox = motion(Box);

export default function PageMotion(props: PageMotionProps) {
  const { children, ...xprops } = props;
  const id = useId();

  return (
    <MotionBox
      id={id}
      py={{ base: "18px", md: "30px" }}
      pb={{ base: "48px", md: "80px" }}
      pos="relative"
      minH="86vh"
      overflowY={"overlay" as any}
      initial={{ opacity: 0, y: 100 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 100 }}
      transition={{
        staggerChildren: 0.5,
        opacity: { type: "spring", stiffness: 100 },
        y: { type: "spring", stiffness: 100 },
      }}
      willChange="height"
      key={id}
      {...xprops}
    >
      {children}
    </MotionBox>
  );
}
